import { TimerGetType } from "models/timer_type";

export function formatDateYYYYMMDDtoLong(dateString: string) {
    const [year, month, day] = dateString.split('-').map(Number);

    const date = new Date(year, month - 1, day);

    const formatter = new Intl.DateTimeFormat('pt-BR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });

    return `dia ${formatter.format(date)}`;
}

export function formatDateRange(timers: TimerGetType[]) {
    if (!timers.length) return "";

    const minTimestamp = Math.min(...timers.map(timer => new Date(timer.initialMoment).getTime()));
    const maxTimestamp = Math.max(...timers.map(timer => new Date(timer.finalMoment).getTime()));

    const minDate = new Date(minTimestamp);
    const maxDate = new Date(maxTimestamp);

    const formatDate = (date: Date) => {
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        return `${day}/${month}/${year} ${hours}:${minutes}`;
    };

    return `${formatDate(minDate)} até ${formatDate(maxDate)}`;
}

export function formatSingleTimer(timer: TimerGetType): string {
    const initialDate = new Date(timer.initialMoment);
    const finalDate = new Date(timer.finalMoment);

    const formatDate = (date: Date): string => {
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        return `${day}/${month}/${year} ${hours}:${minutes}`;
    };

    return `${formatDate(initialDate)} até ${formatDate(finalDate)}`;
}